import { ReactNode } from 'react';

import { ProgramType } from 'types';

import { useAuth } from './authProvider';

export const RequirePalmettoUserHasProgramTypes = ({
  children,
  requiredProgramTypes,
  checkAllProgramTypes,
}: {
  children: ReactNode;
  requiredProgramTypes: ProgramType[];
  checkAllProgramTypes?: boolean;
}) => {
  const { organizationData } = useAuth();
  let show = false;
  if (checkAllProgramTypes) {
    show =
      requiredProgramTypes.every((programType) => organizationData?.programTypes?.includes(programType)) || false;
  } else {
    show =
      requiredProgramTypes.some((programType) => organizationData?.programTypes?.includes(programType)) || false;
  }
  return show ? <>{children}</> : null;
};
